import classic from "./assets/sounds/classic.mp3";
import rooster from "./assets/sounds/rooster.mp3";
import trumpet from "./assets/sounds/trumpet.mp3";
import birds from "./assets/sounds/birds.mp3";
import ocean from "./assets/sounds/ocean.mp3";
import rain from "./assets/sounds/rain.mp3";

export const pad = (n) => (n < 10 ? `0${n}` : `${n}`);

export const colorOptions = [
  "redish",
  "purplish",
  "pinkish",
  "greenish",
  "orangish",
  "blueish",
];

export const soundOptions = [
  "classic",
  "rooster",
  "trumpet",
  "birds",
  "ocean",
  "rain",
];

export const soundSources = [classic, rooster, trumpet, birds, ocean, rain];
